<template>
  <div>
    <el-button icon="el-icon-refresh" @click="$refresh(getIngredientsList)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="辅料名称">
            <el-input v-model="searchForm.ingredientsName" placeholder="请输入辅料名称"/>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getIngredientsList, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getIngredientsList, { ingredientsName: '' })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 操作按钮 -->
      <div class="button">
        <el-button icon="el-icon-plus" type="primary" @click="addingredients">新增辅料</el-button>
        <el-button icon="el-icon-delete" type="danger" @click="deleteIngredientsList">批量删除</el-button>
      </div>
      <!-- 辅料列表 -->
      <el-table v-loading="loading" border ref="multipleTable" :data="ingredientsList" :max-height="tableHeight"
        @selection-change="val => $handleSelectionChange(val, true)">
        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="ingredientsName" label="辅料名称"/>
        <el-table-column prop="unit" label="计量单位"/>
        <el-table-column prop="minNumber" label="最低数量"/>
        <el-table-column prop="price" label="单价/元"/>
        <el-table-column prop="createTime" label="创建时间" min-width="160"/>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button icon="el-icon-edit" type="primary" @click="editIngredients(scope.row)">编辑</el-button>
            <el-button icon="el-icon-delete" type="danger" @click="deleteIngredients(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增或编辑弹框 -->
      <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="350px"
        :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
          <el-form-item label="辅料名称" prop="ingredientsName">
            <el-input v-model="editForm.ingredientsName" placeholder="请输入辅料名称"/>
          </el-form-item>
          <el-form-item label="计量单位" prop="unit">
            <el-select v-model="editForm.unit" placeholder="请选择计量单位">
              <el-option v-for="item in ['g', '份', '根', '个']" :key="item" :label="item" :value="item"/>
            </el-select>
          </el-form-item>
          <el-form-item label="最低数量" prop="minNumber">
            <el-input v-model.number="editForm.minNumber" placeholder="请输入最低数量"/>
          </el-form-item>
          <el-form-item label="辅料单价" prop="price">
            <el-input v-model="editForm.price" oninput="value=value.replace(/[^\d.]/g,'')" placeholder="请输入收费标准">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" v-if="dialogTitle == '新增辅料'" @click="addSave">保存新增</el-button>
          <el-button type="success" v-if="dialogTitle == '编辑辅料'" @click="editSave">保存修改</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getIngredientsList)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { ingredientsList, ingredientsEdit, ingredientsAdd, ingredientsDelete } from "@/api/ingredients"; // 辅料请求
export default {
  data() {
    return {
      loading: true, // 加载中
      searchForm: { ingredientsName: null }, // 查询表单
      ingredientsList: [], // 辅料列表
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      editFormRules: {
        ingredientsName: [{required: true, message: "辅料名称不能为空！", trigger: "blur"}],
        unit: [{required: true, message: "计量单位不能为空！", trigger: "change"}],
        minNumber: [{required: true, message: "最低数量不能为空！"}, {type: 'number', message: "数量为整数格式！"}],
        price: [{required: true, message: "收费标准不能为空！", trigger: "blur"}],
      }, // 验证规则
      multipleSelection: [], // 多选选中项
      tableHeight: 0, // 表格最大高度
    };
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getIngredientsList(); // 页面初始化获取辅料列表
  },
  methods: {
    // 请求所有辅料列表
    async getIngredientsList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm };
      let { total, rows, code } = await ingredientsList(params);
      
      if (code == 200) {
        this.total = total;
        this.ingredientsList = rows;
      }
      this.loading = false;
    },
    // 新增辅料
    addingredients() {
      this.dialogVisible = true;
      this.dialogTitle = "新增辅料";
      this.editForm = { ingredientsName: null, unit: null, minNumber: null, price: null };
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          ingredientsAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增辅料成功！");

            this.dialogVisible = false;
            this.$refresh(this.getIngredientsList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 编辑辅料信息
    async editIngredients(row) {
      this.editForm = JSON.parse(JSON.stringify(row));
      this.dialogTitle = "编辑辅料";
      this.dialogVisible = true;
    },
    // 保存辅料修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          ingredientsEdit(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改辅料成功！");

            this.dialogVisible = false;
            this.$refresh(this.getIngredientsList);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除辅料
    deleteIngredients(row) {
      this.$confirm('确认删除该辅料？').then(_ => { this.del(row.ingredientsId) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await ingredientsDelete(id);
      if (code == 200) this.$message.success("删除辅料成功！");
      this.$refresh(this.getIngredientsList);
    },
    // 批量删除辅料
    deleteIngredientsList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何辅料");
      else {
        selected.forEach(item => { selectedId.push(item.ingredientsId) });
        this.$confirm('确认删除该辅料？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    }
  },
};
</script>